<template>
  <div class="functionMap">
    <div class="function_box">
      <img src="../../common/assets/functionMap2.png" alt="">
      <span>功能地图</span>
    </div>
    <div class="function_content">
      <map-templete :datas="mapData" @mapRestive="mapRestive()"></map-templete>
    </div>
    <div class="map_bottom">
      <img src="../../common/assets/mapBottom2.png" alt="" @click="mapbackClick">
    </div>
  </div>
</template>

<script>
import mapTemplete from "@/components/functionMap/map-templete.vue";
export default {
  name: "FunctionMap",
  data() {
    return {
      mapData: [
        {
          name: "数据服务",
          icon: require("@/common/assets/mapimg1.png"),
          list: [
            { name: "分钟级监控", url: "/main/monitorNew" },
            { name: "数据回采导出", url: "/main/stoping" },
            { name: "数据定制下载", url: "/main/customization" },
          ],
        },
        {
          name: "素材中心",
          icon: require("@/common/assets/mapimg2.png"),
          list: [
            { name: "舆情", url: "/main/ment" },
            { name: "爆文中心", url: "/main/burst" },
            { name: "今日热文", url: "/main/hottext" },
          ],
        },
        {
          name: "会员中心",
          icon: require("@/common/assets/mapimg3.png"),
          list: [
            { name: "会员使用情况", url: "/main/center?tabSt=1" },
            { name: "购买续费", url: "/main/center?tabSt=2" },
            { name: "API充值续费", url: "/main/interface?actnav=3" },
            { name: "会员消费记录", url: "/main/center?tabSt=4" },
            { name: "会员规则体系", url: "/main/center?tabSt=5" },
            { name: "推广列表", url: "/main/center?tabSt=6" },
            { name: "申请发票", url: "/main/getinvoice" },
          ],
        },
        {
          name: "公众号API",
          icon: require("@/common/assets/mapimg4.png"),
          list: [
            { name: "资费标准", url: "/main/interface?actnav=0" },
            { name: "使用示例", url: "/main/interface?actnav=1" },
            { name: "使用情况", url: "/main/interface?actnav=2" },
            { name: "充值续费", url: "/main/interface?actnav=3" },
            { name: "消费记录", url: "/main/interface?actnav=4" },
          ],
        },
        {
          name: "榜单",
          icon: require("@/common/assets/mapimg5.png"),
          list: [
            { name: "小程序榜单", url: "/main/programTop" },
            { name: "公众号榜单", url: "/main/accountList?tabslt=0" },
            { name: "原文应用榜单", url: "/main/applicatio" },
          ],
        },
        {
          name: "公众号服务",
          icon: require("@/common/assets/mapimg8.png"),
          list: [
            { name: "华媒会2022会员招募", url: "/main/founderIntroduction" },
            { name: "微信霸屏推文", url: "/main/tweet" },
            { name: "公众号运营者突破", url: "/main/binding" },
            { name: "公众号突破注册", url: "/main/apptp" },
            { name: "自动登录", url: "/main/automatic" },
            { name: "流量主突破", url: "/main/transfer" },
            { name: "评论开通", url: "/main/opening" },
            { name: "公众号迁移", url: "/main/gzhTransfer" },
            { name: "公众号批量删文", url: "/main/deletion" },
          ],
        },
        {
          name: "搜索",
          icon: require("@/common/assets/mapimg7.png"),
          list: [
            { name: "公众号搜索", url: "/main/index" },
            { name: "文章搜索", url: "/main/articleSearch" },
            { name: "小程序搜索", url: "/main/searchild" },
            { name: "公众号收录" },
          ],
        },
        {
          name: "我的关注",
          icon: require("@/common/assets/mapimg6.png"),
          list: [
            { name: "公众号关注", url: "/main/officialAccount?levelName=公众号关注" },
            { name: "关键词订阅", url: "/main/subscribe?levelName=关键词订阅" },
            { name: "文章收藏", url: "/main/articleCollection?levelName=文章收藏" },
            { name: "公众号关注说明", url: "/main/officialflow" },
         ],
        },
        // {
        //   name: "公众号服务",
        //   icon: require("@/common/assets/mapimg8.png"),
        //   list: [
        //     { name: "华媒会2021会员招募", url: "/main/founderIntroduction" },
        //     { name: "微信霸屏推文", url: "/main/tweet" },
        //     { name: "公众号运营者突破", url: "/main/binding" },
        //     { name: "公众号突破注册", url: "/main/apptp" },
        //     { name: "自动登录", url: "/main/automatic" },
        //     { name: "流量主突破", url: "/main/transfer" },
        //     { name: "评论开通", url: "/main/opening" },
        //     { name: "公众号迁移", url: "/main/gzhTransfer" },
        //     { name: "公众号批量删文", url: "/main/deletion" },
        //   ],
        // },
      ],
    };
  },
  methods: {
    mapRestive() {
      this.$emit('mapRestive')
    },
    mapbackClick() {
      this.$emit('mapbackClick')
    }
  },
  components: {
    mapTemplete,
  },
};
</script>

<style lang="less" scoped>
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  border: none;
  background-color: #fff;
}
.functionMap {
  width:1000px;
  height: 80%;
  // border: solid 1px;
  // left: 48%;
  right: 15%;
  z-index: 700 !important;
  background-color: #fff;
  // border: solid 1px;
  box-sizing: border-box;
  position: fixed;
  margin-top: 80px;
  overflow: hidden;
  // overflow: hidden;
  .function_box {
    box-sizing: border-box;
    width: 100%;
    height: 60px;
    // border: solid 1px;
    > span {
      float: left;
      height: 60px;
      // border: solid 1px;
      margin-left: 10px;
      font-weight: 600;
      font-size: 24px;
      line-height: 60px;
    }
    > img {
      width: 26px;
      height: 26px;
      // border: solid 1px;
      float: left;
      display: inline-block;
      margin-top: calc(60px/2 - 26px/2);
    }
  }
  .function_content {
    // overflow: hidden;
    // display: flex;
    // justify-content: space-between;
    display: inline-block;
    // border: solid 1px;
    height: calc(99% - 80px);
    width: 100%;
    column-count: 4;
    column-gap: 3;
    padding: 0 20px;
    -webkit-column-count: 4;
    -moz-column-count: 4;
    box-sizing: border-box;
    // div {
    //   width: 100%;
    //   min-height: 60px;
    //   display: inline-block;
    //   border: solid 1px;
    //   margin-top: 20px;
    // }
  }
}
.map_bottom {
  width: 120%;
  cursor: pointer;
  // margin-bottom: 0;
  margin-left: calc(100%/2 - 120%/2);
  > img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/functionMap/index.vue